module.exports = __webpack_public_path__ + "static/img/alex_bday_arrangement.9782496.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/art/compressed/plants/alex_bday_arrangement.jpg
// module id = Zt5C
// module chunks = 1